import { useState, useRef, TouchEvent, ReactNode } from "react";

export interface SwipeAction {
  label: string;
  icon: string;
  color: string; // tailwind bg-* class
  onClick: () => void;
}

interface Props {
  actions: SwipeAction[];
  children: ReactNode;
}

export function SwipeRow({ actions, children }: Props) {
  const [offset, setOffset] = useState(0);
  const startX = useRef<number | null>(null);
  const startOffset = useRef<number>(0);
  const max = actions.length * 56;

  const onTouchStart = (e: TouchEvent) => {
    startX.current = e.touches[0].clientX;
    startOffset.current = offset;
  };
  const onTouchMove = (e: TouchEvent) => {
    if (startX.current === null) return;
    const dx = e.touches[0].clientX - startX.current;
    setOffset(Math.min(0, Math.max(-max, dx + startOffset.current)));
  };
  const onTouchEnd = () => {
    setOffset(prev => prev < -max / 2 ? -max : 0);
    startX.current = null;
  };

  return (
    <div className="relative overflow-hidden rounded-xl mb-2">
      <div className="absolute inset-y-0 right-0 flex">
        {actions.map(a => (
          <button
            key={a.label}
            onClick={(e) => { e.stopPropagation(); setOffset(0); a.onClick(); }}
            className={`w-14 flex flex-col items-center justify-center text-white text-[9px] font-semibold ${a.color}`}
          >
            <span className="text-base">{a.icon}</span>
            {a.label}
          </button>
        ))}
      </div>
      <div
        className="bg-attic-surface border border-attic-border rounded-xl transition-transform"
        style={{ transform: `translateX(${offset}px)` }}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        {children}
      </div>
    </div>
  );
}
